import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { StationSelectionComponent } from './component/station-selection/station-selection.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { ListModule } from 'src/app/shared/list/list.module';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  declarations: [
    StationSelectionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ListModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  exports: [
    StationSelectionComponent
  ]

})
export class StationSelectionModule { }
